import useScreenSize from "hoc/useScreenSize";
import { RootState } from "interfaces/generics.type";
import LazyBackgroundImage from "modules/lazy-background-image/LazyBackgroundImage";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import isFeatureEnabled from "util/helper/isFeatureEnabled";
import styles from "./homebnpl.module.scss";
const OldHomeBnpl = dynamic(() => import(/* webpackChunkName: "old home bnpl" */ "./OldHomeBnpl"));

function HomeBnpl() {
  const router = useRouter();
  const [isMobile] = useScreenSize();
  const auth = useSelector((state: RootState) => state.authenticationState);
  const { expConfigurations } = auth;
  const isAffirmEnabled = isFeatureEnabled(expConfigurations, "affirm");

  if (!isAffirmEnabled) {
    return <OldHomeBnpl />;
  }

  return (
    <div
      className={styles.affirm_banner_container}
      onClick={() => router.push("/financing")}
    >
      <LazyBackgroundImage
        src={getRelativeImagePath(`/cms/pubicImages/images/affirm-banner-${isMobile ? "mobile" : "desktop"}.webp`)}
        className={styles.affirm_banner_image}
      />
    </div>
  );
}

export default HomeBnpl;
